// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/myagent." + chunkId + "." + {"134":"df4b103c","677":"b10a87e9"}[chunkId] + ".chunk.js";
};